import {
  MapTool,
  MapUtil,
  DataQuery,
  DataValueFormatter
} from "cartovista";
import BtnInfoPanToolExtend from "./BtnInfoPanToolExtend";
import "../../css/InfoModal.css";﻿

    var InfoModal = MapTool.extend({
      initialize: function(addMapTool) {
          window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
          this._$modal = $('<div class="InfoModal-modal modal fade" tabindex="-1" role="dialog">' +
                                    '<div class="modal-dialog modal-lg">' +
                                        '<div class="modal-content">' +
                                            '<div class="modal-header">' +
                                            '<h4 class="modal-title">' + C.MAP_TOOLS.INFO_MODAL.MODAL_TITLE + '</h4>' +
                                            '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                                            '</div>' +
                                            '<div class="modal-body"></div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>');
          this._addMapTool = addMapTool;
      }
      });

      InfoModal.prototype._onCartoVistaMapLoaded = function(evt) {
      this._map = window.cartovista.externalInterface.map;
      this._mapController = window.cartovista.getMapController(this._map);
      this._$divMap = $(this._mapController._divMap);
      if(this._addMapTool){
          this._$btn = $("#InfoModal");
          var options = {
              "spriteCssClass": "cv-icon InfoModal-btn",
              "toggleClassNames": "cv-state-active"
          };
          MapTool.prototype.initialize.call(this, this._$btn[0], {"map": this._map, "mapController": this._mapController}, options);
          window.cartovista.getUIController(this._map).cvToggleGroup.addElement(this);
      } else{
          window.cartovista.addEventListener("Extend_onBtnInfoPanToolMouseUp", this._onMapClick, this);
      }
      };

      InfoModal.prototype._activated = function() {
      MapTool.prototype._activated.call(this);
      this._$divMap.on("mousemove.InfoModal", _.debounce(this._onMapMouseMove.bind(this), 100));
      this._$divMap.on("click.InfoModal", this._onMapClick.bind(this));
      };

      InfoModal.prototype._deactivated = function() {
      MapTool.prototype._deactivated.call(this);
      this._$divMap.off("mousemove.InfoModal");
      this._$divMap.off("click.InfoModal");
      this._$divMap.removeClass("InfoModal_mouseOverClickableFeature");
      };

      InfoModal.prototype._onMapMouseMove = function(evt) {
      if (this._getFeaturesCollectionsAtPoint(evt).length) {
          this._$divMap.addClass("InfoModal_mouseOverClickableFeature");
      } else {
          this._$divMap.removeClass("InfoModal_mouseOverClickableFeature");
      }
      };

      InfoModal.prototype._onMapClick = function(evt) {
      var featuresCollectionsAtPoint;
      if(this._addMapTool){
          featuresCollectionsAtPoint = this._getFeaturesCollectionsAtPoint(evt);
      } else{
          featuresCollectionsAtPoint = this._getFeaturesCollectionsAtPoint(evt.source.mouseUpEvent);
      }
      if (featuresCollectionsAtPoint.length) {
          this._showModal(featuresCollectionsAtPoint);
      }
      };

      InfoModal.prototype._getFeaturesCollectionsAtPoint = function(e) {
      var MouseCoordinates = this.getNormalizedMouseCoordinates(e),
          x = Math.round(MapUtil.screenXtoMapX(MouseCoordinates.x, this._mapController._map.width, this._mapController._map.extent)),
          y = Math.round(MapUtil.screenYtoMapY(MouseCoordinates.y, this._mapController._map.height, this._mapController._map.extent));
      return _.reduce(C.MAP_TOOLS.INFO_MODAL.LAYERS, function(featuresCollectionsAtPoint, infoTableLayerConfig) {
          //show only if layer is visible
          var layer = this._map.getLayer(infoTableLayerConfig.LAYER_ID);
          if (layer.visible) {
              var featuresCollection = {"LAYER" : layer, "FEATURES" : []},
                  radius = MapUtil.getSearchAtPointRadius(layer, this._map);
              layer.getFeaturesByPoint(x, y, radius, null, function(result) {
                  _.forEach(result.features, function(feature) {
                      //keep only features that are not filteredOut and visible
                      if (!feature.filteredOut && feature.visible) {
                          if (typeof feature.featureCount == "undefined") {
                              featuresCollection.FEATURES.push(feature);
                          } else {
                              featuresCollection.FEATURES = _.concat(feature.features, [feature.centerFeature], featuresCollection.FEATURES);
                          }
                      }
                  });
              });
              if (featuresCollection.FEATURES.length) {
                  featuresCollectionsAtPoint.push(featuresCollection);
              }
          }
          return featuresCollectionsAtPoint;
      }.bind(this), []);
      };

      InfoModal.prototype._showModal = function(featuresCollections) {
      throw new Error("InfoModal._showModal() not implemented.");
      };

      InfoModal.prototype._getFeatureData = function(feature, layer, dataColumnsIds) {
      return new Promise(function(resolve, reject){
          if (dataColumnsIds) {
              var dataColumns = [];
              _.forEach(dataColumnsIds, function(columnsIds, dataTableId){
                  var dataTable = layer.getDataTable(dataTableId);
                  dataColumns = _.concat(dataColumns, dataTable.getDataColumns(columnsIds));
              });
              var featureData = {};
              new DataQuery(dataColumns, [feature.id]).execute(function(queryResult) {
                  _.forEach(dataColumns, function(dataColumn) {
                      featureData[dataColumn.id] = {
                          "NAME": dataColumn.name,
                          "VALUE": DataValueFormatter.formatValue(queryResult.values[dataColumn.dataTable.id][dataColumn.id][0], dataColumn, null, null, true),
                          "TYPE": dataColumn.dataType
                      };
                  });
                  resolve(featureData);
              });
          } else{
              resolve({});
          }
      });
      };
export default InfoModal;
